
(function () {
  'use strict';
  if (window.DaLucaJudgeMeBadgeRemovalV405) return;
  window.DaLucaJudgeMeBadgeRemovalV405 = true;

  const DIAMOND_RE = /diamond\s+(authenticity|transparency)/i;

  function removeDiamondImages(root) {
    root.querySelectorAll('img').forEach(function (img) {
      const label = [
        img.getAttribute('alt') || '',
        img.getAttribute('title') || '',
        img.getAttribute('aria-label') || '',
        img.src || ''
      ].join(' ');

      if (!DIAMOND_RE.test(label) && !/judge\.?me.*diamond/i.test(label)) return;

      let candidate = img;
      let node = img.parentElement;
      while (node && node !== root) {
        const diamonds = node.querySelectorAll(
          'img[alt*="Diamond" i], img[title*="Diamond" i]'
        ).length;

        if (diamonds >= 2) {
          candidate = node;
          break;
        }

        /* Stop before eating the actual Judge.me summary/header. */
        if (
          node.classList &&
          (
            node.classList.contains('jdgm-rev-widg__header') ||
            node.classList.contains('jdgm-rev-widg') ||
            node.classList.contains('jdgm-widget')
          )
        ) {
          break;
        }

        candidate = node;
        node = node.parentElement;
      }

      if (candidate && candidate !== root) candidate.remove();
    });
  }

  function removeSupplementalFrames(root) {
    root.querySelectorAll('iframe').forEach(function (frame) {
      frame.remove();
    });
  }

  function removeScrollableBadgeViewport(root) {
    const header = root.querySelector('.jdgm-rev-widg__header') || root;

    header.querySelectorAll('*').forEach(function (el) {
      if (!(el instanceof HTMLElement)) return;

      /* Never remove core review-summary structures. */
      if (
        el.matches(
          '.jdgm-rev-widg__summary, .jdgm-histogram, .jdgm-histogram__row, ' +
          '.jdgm-row-stars, .jdgm-row-actions, .jdgm-write-rev-link, ' +
          '.jdgm-rev-widg__title'
        ) ||
        el.querySelector(
          '.jdgm-rev-widg__summary, .jdgm-histogram, .jdgm-row-stars, .jdgm-write-rev-link'
        )
      ) {
        return;
      }

      const style = getComputedStyle(el);
      const scrollish =
        /auto|scroll/.test(style.overflow + style.overflowX + style.overflowY) ||
        el.scrollWidth > el.clientWidth + 3 ||
        el.scrollHeight > el.clientHeight + 3;

      if (!scrollish) return;

      const rect = el.getBoundingClientRect();
      const smallViewport = rect.width > 60 && rect.width < 650 && rect.height > 40 && rect.height < 260;
      if (!smallViewport) return;

      const txt = (window.DaLucaI18n.sourceText(el) || '').trim();
      const hasBadgeLikeImages = !!el.querySelector(
        'img[alt*="Diamond" i], img[title*="Diamond" i], iframe'
      );

      /* This targets the exact little scroll box shown in the screenshots.
         It is supplemental; normal review data is deliberately excluded above. */
      if (hasBadgeLikeImages || DIAMOND_RE.test(txt) || txt === '') {
        el.remove();
      }
    });
  }

  function cleanup() {
    document.querySelectorAll(
      '.jdgm-rev-widg, #judgeme_product_reviews, .jdgm-widget'
    ).forEach(function (widget) {
      const section = widget.closest('.shopify-section') || widget;
      removeSupplementalFrames(section);
      removeDiamondImages(section);
      removeScrollableBadgeViewport(widget);
    });
  }

  function schedule() {
    cleanup();
    [60, 180, 450, 900, 1600, 3000, 5000].forEach(function (delay) {
      window.setTimeout(cleanup, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }

  window.addEventListener('load', schedule, { once: true });

  const observer = new MutationObserver(function () {
    window.clearTimeout(observer._dlV405);
    observer._dlV405 = window.setTimeout(cleanup, 60);
  });

  if (document.documentElement) {
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();

